// @flow
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ComboButton from '../buttons/ComboButton';

import * as dyorRoutes from '../../app_routes/ringBuilder';
import * as settingRoutes from '../../app_routes/settings';

import type { DiamondType } from '@types/diamond';
import { trackAddToCart } from '../../utils/googleAnalytics';

type TProps = {
  diamond: DiamondType
};

export default function DiamondComboButton({ diamond }: TProps) {
  const dispatch = useDispatch();
  const currentSettingSku = useSelector(state => state.ringBuilder.setting.sku);
  const savedDiamonds = useSelector(state => state.diamondComparison.ids);
  const handleItemClick = useCallback(
    (name: string) => {
      if (!diamond) return;

      if (name === 'addToCompare') {
        dispatch({
          type: 'TOGGLE_DIAMOND_FOR_COMPARISON',
          item: diamond.list_service_diamond_id,
          redirectTo: '/saved'
        });
      }

      if (name === 'addToDyor') {
        dispatch({
          type: 'SELECT_DYOR_SETTING_SKU_AND_DIAMOND_ID',
          allowNextCompatibleSetting: true,
          payload: {
            settingSku: currentSettingSku,
            diamondId: diamond.list_service_diamond_id
          },
          redirectTo: ({ settingSku, diamondId }) => {
            return (
              (settingSku &&
                dyorRoutes.combinedStep({
                  diamond: diamondId,
                  setting: settingSku
                })) ||
              settingRoutes.searchPath()
            );
          }
        });
      }

      if (name === 'addToBag') {
        trackAddToCart(diamond);

        dispatch({
          type: 'ADD_ITEM_TO_CART',
          payload: { type: 'diamond', id: diamond.list_service_diamond_id }
        });
      }
    },
    [diamond.list_service_diamond_id, currentSettingSku]
  );

  let actions = [
    {
      name: 'addToDyor',
      title: `To ${currentSettingSku ? 'your' : 'a'} Setting`
    },
    { name: 'addToBag', title: `To Shopping Bag` }
  ];

  if (
    savedDiamonds.findIndex(el => el === diamond.list_service_diamond_id) === -1
  ) {
    actions.push({ name: 'addToCompare', title: 'To Comparison Page' });
  }

  return (
    <ComboButton
      actions={actions}
      onClick={handleItemClick}
      initialText='Add This Diamond'
    />
  );
}
